import React, { Dispatch, SetStateAction, useState } from 'react';
import styled from 'styled-components';
import { deleteAllServerData } from '../utils/deleteAllServerData';

interface ModalContentsProps {
  closeModal: () => void;
  setOpenBeforeInitialAlertModal: Dispatch<SetStateAction<boolean>>;
  apartmentIdx: number;
  setDetectChangingData: Dispatch<SetStateAction<boolean>>;
}

export const ModalContents = ({
  closeModal,
  setOpenBeforeInitialAlertModal,
  apartmentIdx,
  setDetectChangingData,
}: ModalContentsProps) => {
  // 1. 입력값을 관리할 상태 추가
  const [confirmText, setConfirmText] = useState('');

  // 2. 입력값이 "DELETE"인지 확인
  const isDeleteValid = confirmText === 'DELETE';

  const handleDelete = () => {
    if (isDeleteValid) {
      deleteAllServerData({
        setOpenBeforeInitialAlertModal,
        apartmentIdx,
        setDetectChangingData,
      });
    }
  };

  return (
    <Wrap>
      <SignTextSection>
        <SignText>
          등록된 차량 데이터를 초기화하시겠습니까?<br />
          기존 데이터는 <span style={{ color: 'red', fontWeight: 'bold' }}> 전부 삭제 </span>되며 복구할 수 없습니다.<br /><br />
          진행하시려면 하단에 <span style={{ color: 'red', fontWeight: 'bold' }}>DELETE</span> 를 입력해 주세요.
        </SignText>
      </SignTextSection>

      {/* 3. 입력 필드 추가 */}
      <InputWrapper>
        <ConfirmInput
          type="text"
          placeholder="DELETE 입력"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
        />
      </InputWrapper>

      <ButtonList>
        <ButtonStyle
          className="yes-button"
          onClick={handleDelete}
          disabled={!isDeleteValid} // 조건이 맞지 않으면 버튼 비활성화
          style={{ opacity: isDeleteValid ? 1 : 0.5, cursor: isDeleteValid ? 'pointer' : 'not-allowed' }}
        >
          예
        </ButtonStyle>
        <ButtonStyle className="close-button" onClick={closeModal}>
          아니오
        </ButtonStyle>
      </ButtonList>
    </Wrap>
  );
};

// --- 스타일 컴포넌트 추가 및 수정 ---

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
`;

const SignTextSection = styled.div`
  display: flex;
  justify-content: start;
  margin-bottom: 20px;
  width: 100%;
`;

const SignText = styled.div`
  font-size: 14px;
  line-height: 1.5;
`;

const InputWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const ConfirmInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  font-weight: bold;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.mainColor.main};
  }
`;

const ButtonList = styled.div`
  display: flex;
  justify-content: center;
`;

const ButtonStyle = styled.button`
  ${({ theme }) => theme.printBtnStyle}
  width: 80px;
  height: 35px;

  &.yes-button {
    border: solid 1px ${({ theme }) => theme.mainColor.dark};
    background-color: ${({ theme }) => theme.mainColor.main};
    color: white;

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.mainColor.dark};
    }
  }

  &.close-button {
    margin-left: 10px;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
  }
`;